<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="row">
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <az-submit color="outline-primary" @click="upload()" :disabled="!ativado"
                            >Carregar Arquivo</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div
                class="indeterminate"
                v-if="$store.state.loading && dados"
            ></div>
            <div class="determinate" v-else></div>
        </div>


        <div class="d-flex justify-content-center mb-3" v-if="dados && dados.retorno && dados.retorno.length">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="visao == 'resumo' ? 'active' : ''" @click.prevent="selecionar('resumo')">
                        Resumo
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="visao == 'Operadora' ? 'active' : ''" @click.prevent="selecionar('Operadora')">
                        Operadora
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="visao == 'Procedimentos' ? 'active' : ''" @click.prevent="selecionar('Procedimentos')">
                        Procedimentos
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="visao == 'Prestadores' ? 'active' : ''" @click.prevent="selecionar('Prestadores')">
                        Prestadores
                    </a>
                </li>
            </ul>
        </div>

        <az-empty-state v-else />

        <template v-if="dados && dados.retorno && dados.retorno.length">

            <!-- resumo -->
            <template v-if="visao == 'resumo'">

                 <table class="table table-sm bg-white table-hover small cabecalho-fixo" v-if="dados && dados.retorno && dados.retorno && dados.retorno.length">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Grupo</th>
                            <th>Descrição do erro</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(retorno, idx) in dados.retorno">
                            <tr class="table-info" :key="'a'+idx">
                                <td colspan="3">
                                    {{(idx + 1) + ' - ' + retorno.mensagem}}
                                </td>
                            </tr>
                            <tr v-for="(erro, iox) in retorno.erros" :key="'b'+idx+iox">
                                <td style="width: 20px;"></td>
                                <td>
                                    <a href="#" @click.prevent="selecionar(erro.grupo)" class="card-link">
                                        {{ erro.grupo }}
                                    </a>
                                </td>
                                <td class="text-danger">
                                    {{ erro.mensagem }}
                                </td>
                            </tr>
                            <tr :key="'c'+idx" v-if="retorno.ok && retorno.erros.length <= 0">
                                <td style="width: 20px;"></td>
                                <td class="text-success" colspan="3">
                                    Não foram encontrados erros.
                                </td>
                                <td></td>
                            </tr>
                        </template>
                    </tbody>
                 </table>

                <template v-else>

                    <az-empty-state  />

                </template>

            </template>

            <!-- Operadoras -->
            <template v-if="visao == 'Operadora'">

                <table class="table table-sm bg-white table-hover small cabecalho-fixo" >
                    <thead>
                        <tr>
                            <th></th>
                            <th>Descrição</th>
                            <th>ANS</th>
                            <th>Contratos</th>
                            <th>Versão TISS</th>
                            <th>Validação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(retorno, idx) in dados.retorno">
                            <tr class="table-info" :key="'a'+idx">
                                <td colspan="6">
                                    {{(idx + 1) + ' - ' + retorno.mensagem}}
                                </td>
                            </tr>
                            <tr :class="retorno.cabecalho.erro ? 'table-danger' : '' " :key="'b'+idx" v-if="retorno.cabecalho && retorno.cabecalho.operadora">
                                <td style="width: 20px;"></td>
                                <td>
                                    <a href="#" @click.prevent="$util.abrirOperadora(retorno.cabecalho.operadora)" class="card-link">
                                        {{ retorno.cabecalho.operadora.st_operadora }}
                                    </a>
                                    <div class="text-muted" v-if="retorno.cabecalho.operadora.empresa">
                                        {{ $util.formatMask(retorno.cabecalho.operadora.empresa.st_cnpj, 'cnpj') }}
                                    </div>
                                </td>
                                <td>
                                    {{ retorno.cabecalho.operadora.st_registro_ans }}
                                </td>
                                <td>
                                    <div v-for="(contrato, icx) in retorno.cabecalho.operadora.contrato_operadoras" :key="icx">
                                        <span class="text-muted">{{ contrato.st_descricao_arquivo_contrato }}</span>
                                        {{ contrato.st_numero_prestador }}
                                    </div>
                                </td>
                                <td>
                                    <span v-if="retorno.cabecalho.operadora.guia_operadora">
                                        {{ retorno.cabecalho.operadora.guia_operadora.st_versao_tiss }}
                                    </span>
                                </td>
                                <td >
                                    <span class="text-error" v-if="retorno.cabecalho.erro">
                                        {{ retorno.cabecalho.contratoOperadoraErro }}
                                    </span>
                                    <span class="text-success" v-else>
                                        Ok
                                    </span>
                                </td>
                            </tr>
                            <tr :key="'c'+idx" v-else>
                                <td style="width: 20px;"></td>
                                <td class="text-danger" colspan="5">
                                    Não foi possível verificar os dados da operadora.
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </template>

            <!-- Procedimentos -->
            <template v-if="visao == 'Procedimentos'">

                <table class="table table-sm bg-white table-hover small cabecalho-fixo">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Procedimento</th>
                            <th>Código</th>
                            <th>Tabela</th>
                            <th>Valores</th>
                            <th>Validação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(retorno, idx) in dados.retorno">
                            <tr class="table-info" :key="'a'+idx">
                                <td colspan="6">
                                    {{(idx + 1) + ' - ' + retorno.mensagem}}
                                </td>
                            </tr>
                            <tr :class="proc.erro ? 'table-danger' : '' " v-for="(proc, iox) in retorno.procedimentos" :key="'b'+idx+iox" >
                                <td style="width: 20px;"></td>
                                <td style="max-width: 400px;">
                                    <a href="#" @click.prevent="$util.abrirProcedimento(proc.procedimentoSistema.procedimento)" class="card-link" v-if="proc.procedimentoSistema && proc.procedimentoSistema.procedimento">
                                        {{ proc.procedimento.descricaoProcedimento }}
                                    </a>
                                    <span v-else>
                                        {{ proc.procedimento.descricaoProcedimento }}
                                    </span>
                                </td>
                                <td>
                                    {{ proc.procedimento.codigoProcedimento }}
                                </td>
                                <td>
                                    {{ proc.procedimento.codigoTabela }}
                                </td>
                                <td>
                                    {{ $util.formatMoeda(proc.valorUnitario) }} 
                                    <div class="text-muted" v-if="proc.erro && proc.procedimentoSistema && proc.procedimentoSistema.itemTabela">
                                        {{ $util.formatMoeda(proc.procedimentoSistema.itemTabela.valor) }}
                                    </div>
                                </td>
                                <td >
                                    <span class="text-danger" v-if="proc.erro">
                                        {{ proc.mensagem }}
                                    </span>
                                    <span class="text-success" v-else>
                                        Ok
                                    </span>
                                </td>
                            </tr>
                             <tr :key="'c'+idx" v-if="!retorno.procedimentos || retorno.procedimentos.length <= 0">
                                <td style="width: 20px;"></td>
                                <td class="text-danger" colspan="5">
                                    Nenhum procedimento foi validado neste arquivo.
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </template>

            <!-- Prestadores -->
            <template v-if="visao == 'Prestadores'">

                <table class="table table-sm bg-white table-hover small cabecalho-fixo">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Nome</th>
                            <th>CPF</th>
                            <th>Conselho</th>
                            <th>Validação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(retorno, idx) in dados.retorno">
                            <tr class="table-info" :key="'a'+idx">
                                <td colspan="5">
                                    {{(idx + 1) + ' - ' + retorno.mensagem}}
                                </td>
                            </tr>
                            <tr :class="med.erro ? 'table-danger' : '' " v-for="(med, iox) in retorno.medicos" :key="'b'+idx+iox">
                                <td style="width: 20px;"></td>
                                <td style="max-width: 400px;">
                                    <a href="#" @click.prevent="$util.abrirMedico(med.medicoSistema)" class="card-link" v-if="med.medicoSistema">
                                        {{ med.equipeSadt.nomeProf }}
                                    </a>
                                    <span v-else>
                                        {{ med.equipeSadt.nomeProf }}
                                    </span>
                                </td>
                                <td>
                                    <template v-if="med.equipeSadt && med.equipeSadt.codProfissional && med.equipeSadt.codProfissional.cpfContratado">
                                        {{ med.equipeSadt.codProfissional.cpfContratado }}
                                    </template>
                                </td>
                                <td>
                                    {{ med.equipeSadt.numeroConselhoProfissional }}
                                    <template v-if="med.estado.st_sigla">{{' / ' + med.estado.st_sigla}}</template>
                                    <template v-if="med.conselho.st_sigla">{{' / ' + med.conselho.st_sigla}}</template>
                                </td>                           
                                <td >
                                    <span class="text-danger" v-if="med.erro">
                                        {{ med.mensagem }}
                                    </span>
                                    <span class="text-success" v-else>
                                        Ok
                                    </span>
                                </td>
                            </tr>
                            <tr :key="'c'+idx" v-if="!retorno.medicos || retorno.medicos.length <= 0">
                                <td style="width: 20px;"></td>
                                <td class="text-danger" colspan="4">
                                    Nenhum prestador foi validado neste arquivo.
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </template>



        </template>

    </div>
</template>

<script>
// import _ from 'lodash';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            visao: 'resumo',
            dados: null, 
            ativado: false, 
        }
    },

    components: { 
        AzSubmit,
        AzEmptyState, 
    },

    methods: { 
        selecionar (opcao) {  
            this.visao = opcao;
        },

        upload() {
            var downloadAnchorNode = document.createElement("input");
            downloadAnchorNode.setAttribute("type", "file");
            downloadAnchorNode.setAttribute("class", "d-none");
            downloadAnchorNode.setAttribute("multiple", "multiple");
            downloadAnchorNode.setAttribute("accept", ".xml");
            downloadAnchorNode.onchange = () => {
                this.posUpload(downloadAnchorNode);
            };
            document.body.appendChild(downloadAnchorNode);
            downloadAnchorNode.click();
        },
        posUpload(el) {
            var file = el.files[0];
            if (file) {

                let promises = [];
                for (let file of el.files) {
                    let filePromise = new Promise(resolve => {
                        let reader = new FileReader();
                        reader.readAsText(file);
                        reader.onload = () => resolve(reader.result);
                    });
                    promises.push(filePromise);
                }
                Promise.all(promises)
                    .then(fileContents => {

                        this.$store.commit("loading", true);

                        const parms = {arrayXML: [...fileContents]};

                        this.axios
                            .post("/valida/faturamento", parms)
                            .then(res => {
                                this.visao = 'resumo';
                                this.dados = res.data;
                            })
                            .finally(() => {
                                this.$store.commit("loading", false);
                            });

                    })
                    .catch(() => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: "Falha lendo arquivo.",
                            life: 3000
                        });
                    });
                
            }
        },

    },

    mounted() { 
        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Validação Arquivo TISS Legado", path: "/config/valid/faturamento" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.valid_permissao(this, 103, () => { 
            this.ativado = true;
        });
    }
}
</script>